/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightSupportProjectionRequest
 */
export interface FlightSupportProjectionRequest {
    /**
     *
     * @type {string}
     * @memberof FlightSupportProjectionRequest
     */
    userId: string;
    /**
     * Canonical Search booking UUID, kept as a string so malformed IDs share the not-found response.
     * @type {string}
     * @memberof FlightSupportProjectionRequest
     */
    bookingId: string;
    /**
     *
     * @type {number}
     * @memberof FlightSupportProjectionRequest
     */
    limit?: number;
    /**
     * Client-opaque Search-issued sequencing cursor bound to this booking. The cursor is base64-encoded, not encrypted or signed, and contains internal ordering fields. It is not an authorization token or integrity proof; owner scope and the booking predicate are enforced independently, so changing it can only move within the same allowlisted chronology.
     * @type {string}
     * @memberof FlightSupportProjectionRequest
     */
    cursor?: string | null;
}

/**
 * Check if a given object implements the FlightSupportProjectionRequest interface.
 */
export function instanceOfFlightSupportProjectionRequest(value: object): value is FlightSupportProjectionRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function FlightSupportProjectionRequestFromJSON(json: any): FlightSupportProjectionRequest {
    return FlightSupportProjectionRequestFromJSONTyped(json, false);
}

export function FlightSupportProjectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSupportProjectionRequest {
    if (json == null) {
        return json;
    }
    return {

        'userId': json['user_id'],
        'bookingId': json['booking_id'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'cursor': json['cursor'] == null ? undefined : json['cursor'],
    };
}

export function FlightSupportProjectionRequestToJSON(json: any): FlightSupportProjectionRequest {
    return FlightSupportProjectionRequestToJSONTyped(json, false);
}

export function FlightSupportProjectionRequestToJSONTyped(value?: FlightSupportProjectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'user_id': value['userId'],
        'booking_id': value['bookingId'],
        'limit': value['limit'],
        'cursor': value['cursor'],
    };
}

